function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#alcohol-free_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.003 0C7.2 0 0 7.2 0 16.003c0 8.804 7.2 16.004 16.003 16.004 8.804 0 16.004-7.2 16.004-16.003C32.007 7.2 24.8 0 16.004 0z",
  fill: "#E24C4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.998 16.003c0-7.2-5.801-13-13.002-13-7.2 0-12.994 5.8-12.994 13s5.801 13.002 13.002 13.002c7.2 0 12.994-5.801 12.994-13.002z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.803 13.599c.704-.9 1.097-2.103 1.097-3.298V7.003h2.398v3.298c0 1.203.4 2.3 1.097 3.298.703.998 1.097 2.102 1.097 3.298v7.101c0 .598-.5.999-.999.999h-4.5c-.597 0-.998-.5-.998-.999v-7.101c-.197-1.196.105-2.398.808-3.298zM14.302 14.597c.5.802.9 1.8.9 2.897 0 2.3-1.498 4.198-3.298 4.198s-3.298-1.898-3.298-4.198c0-1.096.303-2.102.9-2.897h4.796z",
  fill: "#3F4448"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.396 20.103h-.998v4.5h.998v-4.5z",
  fill: "#3F4448"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.598 25.004h4.605c-.196-.598-1.202-.999-2.299-.999s-2.004.394-2.306.999z",
  fill: "#3F4448"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.598 25.503l-2.095 2.095L4.402 6.497l2.095-2.095 21.101 21.1z",
  fill: "#E24C4B"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alcohol-free_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})));

function SvgAlcoholFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgAlcoholFree;